import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { utilities } from '@weatherbug/common';
import { reduxConnect } from '../../../common';
import { translate } from '../../../common/translation/translate';
import { WeatherDetailsListItem,
    WeatherDetailsCellContainerLeft,
    WeatherDetailsCellContainerRight,
    WeatherDetailsCellLabel,
    WeatherDetailsCellValue } from '../weatherDetailsStyledComponents';
import { isValidDisplayValue } from './formatObsData';

const { units } = utilities;
const defaultObsValue = '--';

const mapStoreStateToProps = storeState => {
    const { selectedStationObservations, units: storeStateUnits } =  storeState ?? {};
    const { tempUnit } = storeStateUnits ?? {};
    const { dpt: dewPoint } = selectedStationObservations?.data?.wsobs?.so ?? {};
    const { ma: rainMonthly } = selectedStationObservations?.data?.pr ?? {};

    return {
        dewPoint,
        rainMonthly,
        tempUnit,
        lengthUnit: tempUnit
    };
};

const mapDispatchToProps = {
};

// eslint-disable-next-line react/display-name
export const DewpointAndMonthlyRainView = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ dewPoint, rainMonthly, tempUnit, lengthUnit }) => {
    const lengthUnitAbbrev = units.lengthUnitAbbreviations[lengthUnit];
    const tempUnitAbbrev = units.temperatureUnitAbbreviations[tempUnit];

    const displayDewPoint = Math.abs(dewPoint) >= 0 && isValidDisplayValue(dewPoint) ? `${dewPoint}${tempUnitAbbrev}` : defaultObsValue;

    const displayMonthlyRain = rainMonthly >= 0 && isValidDisplayValue(rainMonthly) ? `${rainMonthly}${lengthUnitAbbrev}` : defaultObsValue;

    return (
        <WeatherDetailsListItem key='dewpoint-m.rain'>
            <WeatherDetailsCellContainerLeft>
                <WeatherDetailsCellLabel>{translate('dewpoint')}</WeatherDetailsCellLabel>
                <WeatherDetailsCellValue>{displayDewPoint}</WeatherDetailsCellValue>
            </WeatherDetailsCellContainerLeft>
            <WeatherDetailsCellContainerRight>
                <WeatherDetailsCellLabel>{translate('monthlyRain')}</WeatherDetailsCellLabel>
                <WeatherDetailsCellValue>{displayMonthlyRain}</WeatherDetailsCellValue>
            </WeatherDetailsCellContainerRight>
        </WeatherDetailsListItem>
    );
}));

DewpointAndMonthlyRainView.propTypes = {
    dewPoint: PropTypes.number,
    rainMonthly: PropTypes.string,
    tempUnit: PropTypes.number,
    lengthUnit: PropTypes.number
};

DewpointAndMonthlyRainView.displayName = 'DewpointAndMonthlyRainView';
